import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// Initial state
const state = {
    quickTasksList: [],
    totalPages: 0,
    totalTask: 0,
    ticketsPerPage: 0,
    taskPerPage: 0,
    taskCount: 0,
    unnotifiedTasks: [],
    tasks: [],
    task: [],
    status: "",
    search: "",
    currentPage: 1,
    totalRecords: 0,
    totalRows: 0,
    teams: [],
    team: [],
    filters: {},
};

const getters = {
    taskTypesList: (state) => state.quickTasksList,
    tasks: (state) => {
        return state.tasks;
    },
    task: (state) => {
        return state.task;
    },
    status: (state) => {
        return state.status;
    },
    search: (state) => {
        return state.search;
    },
    currentPage: (state) => {
        return state.currentPage;
    },
    totalPages: (state) => {
        return state.totalPages;
    },
    totalRows: (state) => {
        return state.totalRows;
    },
    totalRecords: (state) => {
        return state.totalRecords;
    },
    totalTask: (state) => {
        return state.totalTask;
    },
    taskPerPage: (state) => {
        return state.taskPerPage;
    },
    quickTaskPerPage: (state) => {
        return state.quickTaskPerPage;
    },
    filters: (state) => {
        return state.filters;
    },
};

const mutations = {

    SET_TASKS(state, tasks) {
        state.tasks = tasks;
    },
    SET_TASK(state, task) {
        state.task = task;
    },

    SET_TOTAL_PAGES(state, totalPages) {
        state.totalPages = totalPages;
    },
    SET_TOTAL_ROWS(state, totalRows) {
        state.totalRows = totalRows;
    },
    SET_TOTAL_RECORDS(state, totalRecords) {
        state.totalRecords = totalRecords;
    },
    SET_FILTERS(state, filters) {
        state.filters = filters;
    },
    UPDATE_TASK_STATUS(state, { taskId, status }) {
        const task = state.tasks.find(task => task.id === taskId);
        if (task) {
            task.status = status;
        }
    },
};

const actions = {

    getAllTask({ commit }, [page, status, search, filters,type, entity={}]) {

        console.log("entity  =>", entity);

        const permission = {
            headers: {
                'X-Permission': 'all_tickets_list' // Setting the custom header
            },
            params: {
                page: page,
                status: status,
                search: search,
                filters: filters, // Passing filters as an object
                type: type,
                entity: entity
            }
        };

        commit('SET_FILTERS', filters);
        if(hasPermission('all_tickets_list')){
            axios.get('/common/quick-task', permission)
                .then((response) => {
                    let res = response.data;
                    let totalPages = Math.ceil(res.total / res.per_page);
                    let rows = (res.total < res.per_page) ? res.total : res.per_page;

                    commit('SET_TASKS', res.data);
                    commit('SET_TOTAL_RECORDS', res.total);
                    commit('SET_TOTAL_PAGES', totalPages);
                    commit('SET_TOTAL_ROWS', rows);
                });
        }

    },

    async add({commit}, formData) {
        const headers = {
            'Content-Type': 'application/json', // Adjust if needed based on your backend requirements
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Include if your API requires authentication
        };

        try {
            const response = await axios.post('/common/quick-task', {formData}, {headers});
            return response.data;
        } catch (error) {
            console.error("Error adding quick task:", error);
            throw error;
        }
    },
    async edit({commit}, [id]) {
        if(hasPermission('edit_task')){
            const permission = {
                headers: {
                    'X-Permission': 'edit_task'
                }
            };
            return await axios.get(`/common/quick-task/${id}`, permission).then((response) => {
                let res = response.data;
                commit('SET_TASK', res);
                return res;

            });
        }
    },
    async view({commit}, [id]) {
        if(hasPermission('edit_task')){
            const permission = {
                headers: {
                    'X-Permission': 'edit_task'
                }
            };
            return await axios.get(`/common/quick-task/${id}`, permission).then((response) => {
                let res = response.data;
                commit('SET_TASK', res);
                return res;

            });
        }
    },
    async update({commit}, formData) {
        const headers = {
            'Content-Type': 'application/json', // Adjust if needed based on your backend requirements
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Include if your API requires authentication
        };

        try {
            const response = await axios.put(`/common/quick-task/${formData.id}`, {formData}, {headers});
            return response.data;
        } catch (error) {
            console.error("Error editing quick task:", error);
            throw error;
        }
    },

    async delete({commit}, taskId) {
        const headers = {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };

        try {
            const response = await axios.delete(`/common/quick-task/${taskId}`, {headers});
            return response.data;
        } catch (error) {
            console.error("Error deleting quick task:", error);
            throw error;
        }
    },
    async updateTaskStatus({ commit }, { taskId, status }) {
        const headers = {
            'Content-Type': 'application/json', // Adjust if needed based on your backend requirements
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Include if your API requires authentication
        };

        try {
            // Send the updated status to the backend using Axios
            await axios.put(`/common/quick-task/mark-completed/${taskId}`, { status },{headers});

            // Commit the mutation to update the task status in the store
            commit('UPDATE_TASK_STATUS', { taskId, status });
        } catch (error) {
            // Handle any errors here
            console.error("Failed to update status", error);
            throw error; // Re-throw the error if you want to handle it in the component
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};